import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import BASE_URL from "../constent";

// ========== GET ALL CARTS (ADMIN) ==========
export const fetchAllCarts = createAsyncThunk(
  "carts/fetchAllCarts",
  async (statusList, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      const currency = localStorage.getItem("currency");
      if (!token) throw new Error("No token found");

      let url = `${BASE_URL}/cart/builder/getAllCarts`;

      if (statusList && statusList.length) {
        const statusParam = statusList.join(",");
        url += `?status=${statusList[0]}&subStatus=${statusList[1]}`;
      }
      // console.log(url);

      const response = await axios.get(url, {
        headers: { token, iso: currency },
      });

      return response.data?.data?.length ? response.data.data : [];
    } catch (error) {
      if (error.response?.status === 404) return [];
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to load requests"
      );
    }
  }
);

// ========== GET MY CARTS ==========
export const fetchMyCarts = createAsyncThunk(
  "carts/fetchMyCarts",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      const currency = localStorage.getItem("currency");
      if (!token) throw new Error("No token found");
      // console.log(currency)
      const response = await axios.get(`${BASE_URL}/cart/builder/myCarts`, {
        headers: { token, iso: currency },
        // headers: { token},
      });
      // console.log(response)

      return response.data?.data?.length ? response.data.data : [];
    } catch (error) {
      if (error.response?.status === 404) return [];
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to load requests"
      );
    }
  }
);
// ========== GET One CART ==========
export const fetchOneCart = createAsyncThunk(
  "carts/fetchOneCart",
  async (cartID, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      const currency = localStorage.getItem("currency");
      if (!token) throw new Error("No token found");
      // console.log(currency)
      const response = await axios.get(
        `${BASE_URL}/cart/builder/${cartID}/getOneCart`,
        {
          headers: { token, iso: currency },
          // headers: { token},
        }
      );
      // console.log(response)

      return response.data?.data?.products ? response.data.data.products : null;
    } catch (error) {
      if (error.response?.status === 404) return [];
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to load requests"
      );
    }
  }
);

// ========== SUBMIT TO PENDING ==========
export const submitItemsToPending = createAsyncThunk(
  "carts/submitItemsToPending",
  async (selectedIds, { rejectWithValue }) => {
    try {
      //  console.log(selectedIds)
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");

      if (!selectedIds.length) throw new Error("No IDs provided");

      const response = await axios.post(
        `${BASE_URL}/cart/builder/create`,
        { products: selectedIds },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to submit items"
      );
    }
  }
);

// ========== SUBMIT TO PRICING ==========
export const submitItemsToPricing = createAsyncThunk(
  "carts/submitItemsToPricing",
  async (cartID, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");

      const response = await axios.post(
        `${BASE_URL}/cart/builder/${cartID}/price`,
        {},
        {
          headers: { token },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to submit for pricing"
      );
    }
  }
);

// ========== PAYMENT CART ==========
export const payForCart = createAsyncThunk(
  "carts/payForCart",
  async (cartId, { rejectWithValue }) => {
    try {
      // console.log(cartId)
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");

      const response = await axios.post(
        `${BASE_URL}/cart/payment/${cartId}/paymentProducts`,
        {},
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
          },
        }
      );
      // console.log(response.data)
      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to process payment"
      );
    }
  }
);

// ========== SUBMIT TO REQUEST ==========
export const submitItemsToRequest = createAsyncThunk(
  "carts/submitItemsToRequest",
  async (cartID, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");

      const response = await axios.post(
        `${BASE_URL}/cart/builder/${cartID}/request`,
        {},
        {
          headers: { token },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to submit for pricing"
      );
    }
  }
);

// ========== SUBMIT TO RECEIVED ==========
export const submitItemsToReceived = createAsyncThunk(
  "carts/submitItemsToReceived",
  async (cartID, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");

      const response = await axios.post(
        `${BASE_URL}/cart/builder/${cartID}/received`,
        {},
        {
          headers: { token },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to submit for received"
      );
    }
  }
);

// ========== PAYMENT ShipmentAndPack one Cart (Old) ==========
export const payForShipmentAndPack = createAsyncThunk(
  "carts/payForShipmentAndPack",
  async (selectedCartId, { rejectWithValue }) => {
    try {
      // console.log(selectedCartId)
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");

      const response = await axios.post(
        `${BASE_URL}/cart/payment/${selectedCartId}/paymentPackingAndShipping`,
        {},
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to process payment"
      );
    }
  }
);

// ========== PAYMENT ShipmentAndPack Many (NEW) ==========
export const payForShipmentAndPackMany = createAsyncThunk(
  "carts/payForShipmentAndPackMany",
  async (selectedCartIds, { rejectWithValue }) => {
    try {
      // console.log(selectedCartIds)
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");

      const response = await axios.post(
        `${BASE_URL}/cart/payment/paymentManyPackingAndShipping`,
        { carts: selectedCartIds },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to process payment"
      );
    }
  }
);

// ========== SUBMIT TO SHIPMENT ==========
export const submitItemsToShipment = createAsyncThunk(
  "carts/submitItemsToShipment",
  async ({ cartId, body }, { rejectWithValue }) => {
    // console.log(body)
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");
      const response = await axios.post(
        `${BASE_URL}/cart/builder/${cartId}/shipping`,
        body,
        {
          headers: { token },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to submit for pricing"
      );
    }
  }
);

// ========== SUBMIT TO DELIVRY ==========
export const submitItemsToDelivery = createAsyncThunk(
  "carts/submitItemsToDelivery",
  async ({ cartId }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");
      // console.log(token)
      const response = await axios.post(
        `${BASE_URL}/cart/builder/${cartId}/deliver`,
        {},
        {
          headers: { token },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to submit for pricing"
      );
    }
  }
);

// ========== DELETE CART ==========
export const deleteCart = createAsyncThunk(
  "carts/deleteCart",
  async (cartId, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");

      const response = await axios.delete(
        `${BASE_URL}/cart/builder/${cartId}`,
        {
          headers: { token },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to delete cart"
      );
    }
  }
);

// ========== UPDATE CART ==========
export const updateCart = createAsyncThunk(
  "carts/updateCart",
  async ({ cartId, data }, { rejectWithValue }) => {
    try {
      // console.log(data)
      // console.log(cartId)
      const token = localStorage.getItem("accessToken");
      const currency = localStorage.getItem("currency");
      // console.log(token)
      if (!token) throw new Error("No token found");

      const response = await axios.put(
        `${BASE_URL}/cart/builder/${cartId}`,
        data,
        {
          headers: { token, iso: currency },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to update cart address"
      );
    }
  }
);

// ========== UPDATE CART WITH IMAGE ==========
export const updateCartWithImage = createAsyncThunk(
  "carts/updateCartWithImage",
  async ({ cartId, image }, { rejectWithValue }) => {
    try {
      // console.log('Image file:', image);
      // console.log('Cart ID:', cartId);

      const token = localStorage.getItem("accessToken");
      // console.log('Token:', token);

      if (!token) throw new Error("No token found");
      if (!image) throw new Error("No image file provided");

      // إنشاء FormData لإرسال الملف
      const formData = new FormData();
      formData.append("image", image);

      // يمكنك إضافة معلومات أخرى إذا لزم الأمر
      // formData.append('cartId', cartId);

      const response = await axios.put(
        `${BASE_URL}/cart/builder/${cartId}`,
        formData,
        {
          headers: {
            token,
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to update cart with image"
      );
    }
  }
);

// ========== RESEND CART ==========
export const resendCart = createAsyncThunk(
  "carts/resendCart",
  async (cartId, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");
      const response = await axios.post(
        `${BASE_URL}/cart/builder/${cartId}/resend`,
        {},
        {
          headers: { token },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to delete cart"
      );
    }
  }
);

// ========== CREATE CART TO RECEIVED ==========
export const createCartToReceived = createAsyncThunk(
  "carts/createCartToReceived",
  async (data, { rejectWithValue }) => {
    try {
      //  console.log(data)
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");

      // if (!data.length) throw new Error("No IDs provided");

      const response = await axios.post(
        `${BASE_URL}/cart/builder/receivedOutCart`,
        data,
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to submit items"
      );
    }
  }
);

// ========== OUT CART IS READY ==========
export const OutCartIsReady = createAsyncThunk(
  "carts/OutCartIsReady",
  async (cartId, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");

      const response = await axios.post(
        `${BASE_URL}/cart/builder/${cartId}/OutCartIsReady`,
        {},
        { headers: { token } }
      );
      // console.log("Done")
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to mark cart as ready"
      );
    }
  }
);

// ========== SLICE ==========
const CartsSlice = createSlice({
  name: "carts",
  initialState: {
    allCarts: [],
    carts: [],
    oneCart: [],
    loading: false,
    error: null,
    cartsLoading: false,
    cartsError: null,
    successMessage: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // ========== FETCH ALL CARTS ==========
      .addCase(fetchAllCarts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllCarts.fulfilled, (state, action) => {
        state.loading = false;
        state.allCarts = action.payload;
      })
      .addCase(fetchAllCarts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ========== FETCH MY CARTS ==========
      .addCase(fetchMyCarts.pending, (state) => {
        state.cartsLoading = true;
        state.cartsError = null;
      })
      .addCase(fetchMyCarts.fulfilled, (state, action) => {
        state.cartsLoading = false;
        state.carts = action.payload;
      })
      .addCase(fetchMyCarts.rejected, (state, action) => {
        state.cartsLoading = false;
        state.cartsError = action.payload;
      })

      // ========== SUBMIT TO PENDING ==========
      .addCase(submitItemsToPending.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(submitItemsToPending.fulfilled, (state, action) => {
        state.loading = false;
        state.successMessage = action.payload.message;
      })
      .addCase(submitItemsToPending.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ========== SUBMIT TO PRICING ==========
      .addCase(submitItemsToPricing.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(submitItemsToPricing.fulfilled, (state, action) => {
        state.loading = false;
        state.successMessage = action.payload.message;
      })
      .addCase(submitItemsToPricing.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ========== DELETE CART ==========
      .addCase(deleteCart.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteCart.fulfilled, (state, action) => {
        state.loading = false;
        state.successMessage = action.payload.message;
        state.allCarts = state.allCarts.filter(
          (cart) => cart.id !== action.meta.arg
        );
      })
      .addCase(deleteCart.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ========== PAYMENT CART ==========
      .addCase(payForCart.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(payForCart.fulfilled, (state, action) => {
        state.loading = false;
        state.successMessage = action.payload.message || "Payment successful";
      })
      .addCase(payForCart.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(updateCart.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCart.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateCart.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // One Cart
      .addCase(fetchOneCart.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOneCart.fulfilled, (state, action) => {
        state.loading = false;
        state.oneCart = action.payload;
      })
      .addCase(fetchOneCart.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
    // .addCase(fetchOneCart.pending, (state) => {
    //     state.loading = true;
    //     state.error = null;
    //   })
    //   .addCase(fetchOneCart.fulfilled, (state, action) => {
    //     state.loading = false;
    //     state.allCarts = action.payload;
    //   })
    //   .addCase(fetchOneCart.rejected, (state, action) => {
    //     state.loading = false;
    //     state.error = action.payload;
    //   })
  },
});

export default CartsSlice.reducer;
